export default __webpack_public_path__ + "static/media/tencent-logo.97e72b1e.svg";